// @flow

import React from 'react'
import loadable from '@loadable/component'

const ClientOverviewContent = loadable(() => import('./ClientOverview'))

const ClientOverview = () => {
  return (
    <div>
      <ClientOverviewContent />
    </div>
  )
}

export default ClientOverview
